import { TranslateService } from '@ngx-translate/core';
import { LandingPage } from './../pages/landing/landing';
import { Component, ViewChild } from '@angular/core';
import { Platform } from 'ionic-angular';

import { NavController } from 'ionic-angular';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild('bqNav') nav: NavController;

  public rootPage: any = LandingPage;

  constructor(platform: Platform, private translate: TranslateService) {
    platform.ready().then(() => {
      this.translate.setDefaultLang('es');
      this.translate.use('es');
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts